import React, { type ReactNode } from "react";
import { MESFLogbookEntry } from "./entry";
import { MESFLogbookReport } from "./report";

export { MESFLogbookEntry, MESFLogbookReport };

export { SectionSelector } from "../../controls/section-selector";

export type {
	Section,
	SectionFamily,
	TopSection,
} from "../../controls/section-selector";
export type { SectionEntry } from "./shared/models/SectionEntry";

export {
	getSections,
	getSectionFamilies,
	getTopUsedSections,
} from "../../controls/section-selector";

export {
	getEntriesBySection,
	upsertSectionEntry,
	deleteSectionEntry,
	createSectionEntry,
} from "./shared/repository/SectionRepository";

export const sectionLogbookRoutesMESF: {
	path: string;
	element: ReactNode;
	permission?: string;
}[] = [
	{
		path: "/logbook/entry",
		element: React.createElement(MESFLogbookEntry),
	},
	{
		path: "/logbook/entry/:shiftId",
		element: React.createElement(MESFLogbookEntry),
	},
	{
		path: "/logbook/report",
		element: React.createElement(MESFLogbookReport),
	},
];

export const sectionLogbookNavbar = [
	{
		id: "logbook",
		label: "Logbook",
		items: [
			{
				label: "Logbook Entry",
				to: "/logbook/entry",
			},
			{
				label: "Logbook Report",
				to: "/logbook/report",
			},
		],
	},
];
